import { useMemo } from 'react';
import { useParams } from 'next/navigation';
import { parseSpaceRoute, type SpaceRoute } from 'config/routing';

// The `/spaces` URL the page is on, parsed. The one place that reads the
// catch-all slug; everything else asks this and the pure helpers in
// config/routing (selectionOf, viewOf) what the route means.
export const useSpaceRoute = (): SpaceRoute | null => {
  const params = useParams();
  const slug = params?.slug as string[] | undefined;
  return useMemo(() => parseSpaceRoute(slug), [slug]);
};
